/** From https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

export const fieldValidate = {
  name: (value: unknown) => {
    if (typeof value !== 'string') throw new Error('common.form.error.field.required')
    if (value.length < 1) throw new Error('common.form.error.field.required')
    if (value.includes('@')) throw new Error('settings.input.name-is-not-email')
  },
  notificationEmail: (value: unknown) => {
    if (!value) return
    if (typeof value !== 'string') throw new Error('content.invalid')
    if (!emailRegex.test(value)) throw new Error('settings.input.email-is-not-valid')
  },
  email: (value: unknown) => {
    if (typeof value !== 'string') throw new Error('common.form.error.field.required')
    if (value.length < 1) throw new Error('common.form.error.field.required')
    if (!emailRegex.test(value)) throw new Error('settings.input.email-is-not-valid')
  },
}

export const hasValidation = (key: string): key is keyof typeof fieldValidate => key in fieldValidate
